import type { Chat } from "@/react/types/CommunityInbox/Chat";

import { useChatList } from "./useCommunityChatList";

export const usePinnedBotChat = () => {
  const { chats: botChats = [], isChatsLoading: isBotChatLoading } =
    useChatList({
      filter: "mine",
      per_page: 1,
      isPinned: true,
    });

  return {
    botChat: botChats?.filter((chat: Chat) => !chat.disabled)?.[0],
    isLoading: isBotChatLoading,
  };
};
